import { styled, Box, Dialog, DialogTitle, DialogContent, Button, InputLabel } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    padding: theme.spacing(1),
    maxWidth: '600px',
    width: '100%',
  }
}));

export const ModalTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 700,
  color: '#111827',
  padding: theme.spacing(2, 3),
}));

export const ModalContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 3, 3, 3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}));

export const FormControl = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  flex: 1,
  minWidth: 0,
}));

export const FormLabel = styled(InputLabel)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: '#374151',
  marginBottom: '4px',
}));

export const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  }
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: '#374151',
  borderColor: '#D1D5DB',
  borderRadius: '6px',
  padding: '8px 24px',
  fontWeight: 500,
  '&:hover': {
    borderColor: '#9CA3AF',
    backgroundColor: '#F3F4F6',
  }
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  backgroundColor: '#52786F', // Matching the green theme
  color: '#fff',
  borderRadius: '6px',
  padding: '8px 24px',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: '#3E5C54',
  }
}));
